import React from 'react';
import _ from 'lodash'
import { addDays, areIntervalsOverlapping, differenceInDays, max, min, parseISO } from 'ag-common/facades'
import CalendarTooltip from './CalendarTooltip';
import { CalendarConfig } from '#tools/calendarConfig';


const createVisibleItemsFilter = (startOfCalendar, endOfCalendar) => {
  const calendarRange = {
    start: startOfCalendar,
    end: endOfCalendar,
  }
  return item => {
    const itemRange = { start: parseISO(item.startDate), end: parseISO(item.endDate) }
    return areIntervalsOverlapping(calendarRange, itemRange, {inclusive: true})
  }
}

const Ueberplanung = ({ startOfCalendar, endOfCalendar, startDate, endDate, abteilungen }) => {
  const gridColumn = `${differenceInDays(max([startDate, startOfCalendar]), startOfCalendar) + 2} / span ${differenceInDays(min([endDate, endOfCalendar]), max([startDate, startOfCalendar])) + 1}`;
  const text = `${abteilungen.join(', ')} ${abteilungen.length > 1 ? "sind" : "ist"} überplant`;
  return (
    <CalendarTooltip text={text} position={CalendarTooltip.Position.BOTTOM}>
      {ref => (
        <div className="calendar__ueberplanung" ref={ref} style={{ gridColumn }} data-from={startDate} data-to={endDate}>
        </div>
      )}
    </CalendarTooltip>
  )
}

const Ueberplanungen = ({ ueberplanungen, startOfCalendar, endOfCalendar, calendarType, isDashboardView = false }) => {
  const ueberplanungenInCalendar = ueberplanungen.filter(createVisibleItemsFilter(startOfCalendar, endOfCalendar));

  const numberOfDays = differenceInDays(endOfCalendar, startOfCalendar) + 1;
  const {getBorderColor} = CalendarConfig[calendarType];

  const gridTemplateColumns = isDashboardView ? `repeat(${numberOfDays}, 1fr)` : `284px repeat(${numberOfDays}, 1fr) 40px`

  return (
    <div className="calendar__ueberplanungen" style={{ gridTemplateColumns }}>
      <div className="calendar__ueberplanungen__title">Planungskonflikte</div>
      {_.times(numberOfDays, n => (
        <div
          key={`${calendarType}-${addDays(startOfCalendar, n)}`}
          data-date={addDays(startOfCalendar, n)}
          className="calendar__placeholder"
          style={{ gridColumn: n + 2, borderColor: getBorderColor(addDays(startOfCalendar, n)) }}></div>
      ))}
      {
        ueberplanungenInCalendar.map(({ startDate, endDate, ...ueberplanung }) => (
          <Ueberplanung
            key={`${startDate}-${endDate}`}
            startDate={parseISO(startDate)}
            endDate={parseISO(endDate)}
            startOfCalendar={startOfCalendar}
            endOfCalendar={endOfCalendar}
            {...ueberplanung}
          />
        ))
      }
    </div>
  )
}

export default Ueberplanungen;
